import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { format } from "date-fns";
import { hi } from "date-fns/locale";
import { Link, useNavigate } from "react-router-dom";
import { Circles } from 'react-loader-spinner';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
// import '../components/InternationalDetails2.css'
import DOMPurify from 'dompurify';

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength);
    //return text.substring(0, maxLength) + '...';
  }
  return text;
};

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};

// const local = "http://localhost:44351/api/home/international"
// const online = "https://api.shabdtoday.com/api/home/international"

const local = "http://localhost:44351/api/home/getduniya"
const online = "https://api.shabdtoday.com/api/home/getduniya"
const clicklocal = "http://localhost:44351/api/home/update-viewcount"
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount"

function InternationalDetails2() {
  const [post, setPost] = useState([]);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetching, setFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const observer = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${online}?page=1&limit=5`);
        setPost(response.data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  // Define your base URL for news images
  const handleNewsClick2 = async (slug, mainKhabarId) => {
    try {
      const response = await axios.post(`${clickonline}`, {
        mainKhabarId: mainKhabarId
      });

      if (response.status === 200) {
        // console.log("View count updated successfully", response.data);
        window.location.href = `/News-Details/${slug}`;
      } else {
        console.error("Failed to update view count", response.data);
      }
    } catch (error) {
      console.error("Error updating view count:", error.response ? error.response.data : error.message);
    }
  };


  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी",
      "फरवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्टूबर",
      "नवंबर",
      "दिसंबर",
    ];
    const seconds = date.getSeconds();
    const minute = date.getMinutes();
    var hour = date.getHours();
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
  };

  const getTimeAgoInHindi = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);
    const diffInSeconds = Math.floor((now - past) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} सेकंड पहले`;
    }

    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} मिनट पहले`;
    }

    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} घंटे पहले`;
    }

    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
      return `${diffInDays} दिन पहले`;
    }

    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths} महीने पहले`;
    }

    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} साल पहले`;
  };

  const generateShareLinks = (mainKhabarId, newsTag) => {
    const encodednewsTag = encodeURIComponent(newsTag);
    const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodednewsTag}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encodednewsTag} ${url}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodednewsTag}&url=${url}`,
      instagram: `https://www.instagram.com/`

    };
  };

  const renderHtmlContent = (html) => {
    const sanitizedHtml = DOMPurify.sanitize(html);
    return { __html: sanitizedHtml };
  };


  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        {/* <Circles
          height="30"
          width="30"
          color="#f7265c"
          ariaLabel="circles-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        /> */}
      </div>
    );
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  const baseUrl = "https://api.shabdtoday.com/";
  const image_resize = "https://api.shabdtoday.com/api/home/resize";
  return (
    <div>
      <div id="newsy_block_3-3" className="widget widget_newsy_block_3">
        <div
          className="ak-block ak-block-3  ak-block-column ak-block-module-thumb-round ak-block-width-1 clearfix"
          id="block_65fab515e40bc_4"
        >
          <div className="ak-block-header ak-block-header-style-5 no-tabs mt-2">
            <div
              className="main-wdgt container"
              id="widget-rs-4937"
              data-vars-widget-type="home"
              data-vars-widget-name="astrology"
              data-vars-orderid={10}
            >
              <div>
                <span className="head">
                  <Link to="/World-News" title="दुनिया" >
                    <span style={{ color: "crimson" }}>
                      दुनिया </span>
                  </Link>
                </span>
              </div>
            </div>
          </div>
          <div className="ak-block-inner clearfix">
            <div className="ak-block-post clearfix">
              {post.suggestKhabars.slice(0, 5).map((newsItem) => {
                const shareLinks = generateShareLinks(newsItem.mainKhabarId, newsItem.newsTag);
                return (
                  <article key={newsItem.mainKhabarId} className="bordergap  ak-module ak-module-1-small ak-column-module clearfix post-249 post type-post status-publish format-standard has-post-thumbnail  category-business category-entertainment category-featured category-us-news category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news">
                    <div className="ak-module-inner clearfix">
                      <div className="ak-module-featured">

                        <div className="ak-featured-cover">
                          <Link
                            to={`/News-Details/${newsItem.slug}`}
                            onClick={(e) => {
                              e.preventDefault();
                              handleNewsClick2(newsItem.slug, newsItem.mainKhabarId);
                            }}
                            className="ak-featured-link"
                            rel="bookmark"
                            aria-label=" खबरें और भी"
                            title={stripHtmlTags(newsItem.newsTag)}
                          >
                            <div className="ak-featured-thumb  size-715">
                              <img
                                width={120}
                                height={86}
                                src={baseUrl + newsItem.newsImage}
                                className="post-image"
                                alt={newsItem.slug}
                                data-src={baseUrl + newsItem.newsImage}
                                data-sizes="auto"
                                data-srcset={baseUrl + newsItem.newsImage}
                                data-expand={700}
                                sizes="120px"
                                srcSet={baseUrl + newsItem.newsImage}
                              />
                            </div>
                            <span style={{ color: "grey", fontSize: "12px" }}>
                              {getTimeAgoInHindi(newsItem.date)}
                            </span>
                          </Link>
                        </div>
                      </div>
                      <div className="ak-module-details">
                        <h2 className="ak-module-title">
                          <Link
                            to={`/News-Details/${newsItem.slug}`}
                            onClick={(e) => {
                              e.preventDefault();
                              handleNewsClick2(newsItem.slug, newsItem.mainKhabarId);
                            }}
                            className="ak-featured-link"
                            rel="bookmark"
                            aria-label=" खबरें और भी"
                            title={stripHtmlTags(newsItem.newsTag)}

                          >
                            <span style={{ fontSize: "15px", lineHeight: "20px", fontWeight: "600", textAlign: "justify" }} dangerouslySetInnerHTML={renderHtmlContent(newsItem.newsTag)} />
                            {/* <span style={{ fontSize: "21px", lineHeight: "30px", fontWeight: "600", textAlign: "justify" }}>{stripHtmlTags(post.newsTag,150)}</span> */}
                            {/* <span style={{ fontSize: "25px", lineHeight: "25px" }}>
                              {stripHtmlTags(newsItem.newsTag)}
                            </span> */}
                          </Link>
                        </h2>
                      </div>
                    </div>
                  </article>
                );
              })}

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InternationalDetails2
